import { memo } from 'react';
import { useNavigate } from 'react-router-dom';
import { InlineLoading } from '@carbon/react';

import { useIsReadonly } from 'core/readonly';
import { routes } from 'core/routing';
import ActionButton from 'shared/components/ActionButton';
import FormActions from 'shared/components/FormActions';

const OutputsActions = ({ projectId, onSave, onSaveAs, isLoading, isSaving, isSavingAs, className }) => {
  const navigate = useNavigate();

  const isReadonly = useIsReadonly();

  return (
    <FormActions className={className}>
      {isReadonly ? null : isSaving ? (
        <InlineLoading description="Saving changes" status="active" aria-live="assertive" />
      ) : (
        <ActionButton size="sm" disabled={isLoading || isSavingAs} onClick={onSave}>
          Save
        </ActionButton>
      )}
      {isReadonly ? null : isSavingAs ? (
        <InlineLoading description="Saving changes" status="active" aria-live="assertive" />
      ) : (
        <ActionButton size="sm" disabled={isLoading || isSaving} onClick={onSaveAs}>
          Duplicate
        </ActionButton>
      )}
      <ActionButton
        kind="secondary"
        size="sm"
        disabled={isLoading || isSaving}
        onClick={() => navigate(routes.exportProject(projectId))}
      >
        Print Preview
      </ActionButton>
      <ActionButton disabled={isLoading} size="sm" onClick={() => navigate(routes.dashboard(projectId))}>
        View Dashboard
      </ActionButton>
    </FormActions>
  );
};

export default memo(OutputsActions);
